import { Box, Button, Chip, Typography } from "@mui/material";

export interface BidEntry {
  seatIndex: number;
  playerName: string;
  action: "Atta" | "Pass";
}

interface Props {
  isMyTurn: boolean;
  currentCallerName: string | null;
  onBid: (action: "Atta" | "Pass") => void;
  bidHistory: BidEntry[];
  currentBidderName: string;
  forcedBid?: boolean;
}

export const BiddingPanel = ({
  isMyTurn,
  currentCallerName,
  onBid,
  currentBidderName,
  forcedBid,
}: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(0,0,0,0.88)",
        borderRadius: 2,
        padding: { xs: 1.5, sm: 2 },
        width: "100%",
        maxWidth: { sm: 280 },
        color: "white",
        boxSizing: "border-box",
        textAlign: "center",
        position: "relative",
        zIndex: 1,
        boxShadow: "0 8px 32px rgba(0,0,0,0.55)",
      }}
    >
      <Typography variant="body2" sx={{ mb: { xs: 0.75, sm: 1.5 }, opacity: 0.8, fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
        {isMyTurn
          ? forcedBid
            ? "You must bid Atta! (everyone else passed)"
            : "Your turn to bid!"
          : `Waiting for ${currentBidderName}…`}
      </Typography>

      {currentCallerName && (
        <Chip
          label={`Caller: ${currentCallerName}`}
          color="warning"
          size="small"
          sx={{ mb: 1.5 }}
        />
      )}

      <Box sx={{ display: "flex", gap: { xs: 1, sm: 1.5 }, justifyContent: "center", flexWrap: "wrap" }}>
        <Button
          variant="contained"
          color="success"
          disabled={!isMyTurn}
          onClick={() => onBid("Atta")}
          sx={{ fontWeight: "bold", px: { xs: 2, sm: 3 }, fontSize: { xs: "0.85rem", sm: "0.95rem" } }}
        >
          Atta
        </Button>
        {!forcedBid ? (
          <Button
            variant="outlined"
            color="inherit"
            disabled={!isMyTurn}
            onClick={() => onBid("Pass")}
            sx={{ color: "white", borderColor: "rgba(255,255,255,0.5)", fontWeight: "bold", px: { xs: 2, sm: 3 }, fontSize: { xs: "0.85rem", sm: "0.95rem" } }}
          >
            Pass
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
